
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'PEN',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/PEN.vue